import api from './api';

export interface Student {
  id: string;
  schoolId: string;
  userName: string;
  profileId?: string;
  classId?: string;
  firstName?: string;
  lastName?: string;
  birthdate?: string; // ISO-8601 string from backend
  enabled?: boolean;
  creationDatetime?: string; // ISO-8601 string from backend
  lastAuthenticationDatetime?: string; // ISO-8601 string from backend
}

export interface PageResponse<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface StudentSearchFilters {
  userName?: string;
  firstName?: string;
  lastName?: string;
  classId?: string;
  enabled?: boolean;
}

export interface StudentSearchRequest {
  page?: number;
  size?: number;
  filters?: StudentSearchFilters;
}

export const studentService = {
  searchStudents: async (request: StudentSearchRequest = {}): Promise<PageResponse<Student>> => {
    const searchRequest = {
      page: request.page ?? 0,
      size: request.size ?? 100,
      filters: request.filters || {},
    };
    
    const response = await api.post<PageResponse<Student>>('/{schoolId}/students/search', searchRequest);
    return response.data;
  },

  getStudentById: async (id: string): Promise<Student> => {
    const response = await api.get<Student>(`/{schoolId}/students/${id}`);
    return response.data;
  },

  createStudent: async (student: Omit<Student, 'id' | 'schoolId' | 'creationDatetime' | 'lastAuthenticationDatetime'>): Promise<Student> => {
    const response = await api.post<Student>('/{schoolId}/students', student);
    return response.data;
  },

  updateStudent: async (id: string, student: Omit<Student, 'id' | 'schoolId' | 'creationDatetime' | 'lastAuthenticationDatetime'>): Promise<Student> => {
    const response = await api.put<Student>(`/{schoolId}/students/${id}`, student);
    return response.data;
  },

  deleteStudent: async (id: string): Promise<void> => {
    await api.delete(`/{schoolId}/students/${id}`);
  },

  resetPassword: async (id: string, newPassword: string): Promise<void> => {
    await api.post(`/{schoolId}/students/${id}/reset-password`, { newPassword });
  },
};

